import React, { useState, useRef, useEffect } from "react";

const CardTooltip = ({ children, tooltip, position = "right", className }) => {
  const [visible, setVisible] = useState(false);
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const tooltipRef = useRef(null);

  const handleMouseMove = (e) => {
    const offsetX = 16;
    const offsetY = 16;

    let x = e.clientX + offsetX;
    let y = e.clientY - offsetY;

    if (tooltipRef.current) {
      const rect = tooltipRef.current.getBoundingClientRect();
      switch (position) {
        case "left":
          x = e.clientX - rect.width - offsetX;
          break;
        case "top":
          x = e.clientX - rect.width / 2;
          y = e.clientY - rect.height - offsetY;
          break;
        case "bottom":
          x = e.clientX - rect.width / 2;
          y = e.clientY + offsetY;
          break;
        case "right":
        default:
          break;
      }
    }

    setPos({ x, y });
  };

  useEffect(() => {
    const hide = () => setVisible(false);
    window.addEventListener("scroll", hide);
    window.addEventListener("resize", hide);
    return () => {
      window.removeEventListener("scroll", hide);
      window.removeEventListener("resize", hide);
    };
  }, []);

  return (
    <div
      className="relative inline-block w-full"
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
      onMouseMove={handleMouseMove}
    >
      {children}

      {visible && (
        <div
          ref={tooltipRef}
          className={`fixed z-50 transition-opacity duration-150 ${className}`}
          style={{
            top: `${pos.y}px`,
            left: `${pos.x}px`,
            pointerEvents: "none",
          }}
        >
          <div className="">
            {tooltip}
          </div>
        </div>
      )}
    </div>
  );
};

export default CardTooltip;
